import { CHIP_DEFS, type ChipId } from './config';

export type ChipSlotName = 'primary' | 'secondary' | 'field';
export interface ChipSlot { id: ChipId; cooldownLeft: number; usesLeft: number }
const SINGLE_USE: readonly ChipId[] = ['goldFever', 'pocketClock', 'starElixir'];

export class ChipLoadout {
  primary: ChipSlot;
  secondary: ChipSlot;
  field: ChipSlot;
  constructor(primaryId: ChipId, secondaryId: ChipId, fieldId: ChipId = 'pocketClock') {
    const slots = new Map<ChipId, ChipSlot>();
    const slot = (id: ChipId): ChipSlot => {
      if (!slots.has(id)) slots.set(id, { id, cooldownLeft: 0, usesLeft: SINGLE_USE.includes(id) ? 1 : 99 });
      return slots.get(id)!;
    };
    // Duplicate equipment shares its charges and cooldown; cannot bypass single-use rules.
    this.primary = slot(primaryId); this.secondary = slot(secondaryId); this.field = slot(fieldId);
  }
  private slots(): ChipSlot[] { return [...new Set([this.primary, this.secondary, this.field])]; }
  update(dt: number): void {
    for (const slot of this.slots()) slot.cooldownLeft = Math.max(0, slot.cooldownLeft - dt);
  }
  activate(name: ChipSlotName): ChipId | null {
    const slot = this[name];
    if (slot.cooldownLeft > 0 || slot.usesLeft <= 0) return null;
    slot.usesLeft--; slot.cooldownLeft = CHIP_DEFS[slot.id].cooldown;
    return slot.id;
  }
  reset(): void {
    for (const slot of this.slots()) { slot.cooldownLeft = 0; slot.usesLeft = SINGLE_USE.includes(slot.id) ? 1 : 99; }
  }
}
export function chipProgress(slot: ChipSlot): number {
  return slot.cooldownLeft <= 0 ? 1 : 1 - slot.cooldownLeft / CHIP_DEFS[slot.id].cooldown;
}
